(function (root) {
  'use strict';

  var core = root.CCBatchCalculatorCore;
  if (!core) {
    return;
  }
  var PHASES = core.PHASES.slice();
  var PHASE_LABELS = Object.assign({}, core.PHASE_LABELS);
  var ML_PER_US_FLOZ = core.ML_PER_US_FLOZ;
  var isFiniteNumber = core.isFiniteNumber;
  var numberValue = core.numberValue;
  var roundTo = core.roundTo;
  var exactRange = core.exactRange;
  var validateDataset = core.validateDataset;
  var findRecipe = core.findRecipe;
  var findPreset = core.findPreset;
  var calculate = core.calculate;
  var formatVolumeDual = core.formatVolumeDual;
  var formatMlNumber = core.formatMlNumber;
  var dilutionSummary = core.dilutionSummary;
  var serviceNotes = core.serviceNotes;
  var plainTextSummary = core.plainTextSummary;

  function createElement(documentRef, name, className, text) {
    var element = documentRef.createElement(name);
    if (className) {
      element.className = className;
    }
    if (typeof text === 'string') {
      element.textContent = text;
    }
    return element;
  }

  function setFieldError(component, fieldName, message) {
    var field = component.querySelector('[name="' + fieldName + '"]');
    var error = component.querySelector('[data-error-for="' + fieldName + '"]');
    if (field) {
      field.setAttribute('aria-invalid', message ? 'true' : 'false');
    }
    if (error) {
      error.textContent = message || '';
      error.hidden = !message;
    }
  }

  function clearErrors(component) {
    component.querySelectorAll('[data-error-for]').forEach(function (error) {
      var name = error.getAttribute('data-error-for');
      setFieldError(component, name, '');
    });
    var summary = component.querySelector('[data-error-summary]');
    var list = component.querySelector('[data-error-summary-list]');
    if (summary) {
      summary.hidden = true;
    }
    if (list) {
      list.replaceChildren();
    }
  }

  function renderErrors(component, errors) {
    clearErrors(component);
    var summary = component.querySelector('[data-error-summary]');
    var list = component.querySelector('[data-error-summary-list]');
    Object.keys(errors).forEach(function (fieldName) {
      setFieldError(component, fieldName, errors[fieldName]);
      var field = component.querySelector('[name="' + fieldName + '"]');
      if (field && list) {
        var item = createElement(document, 'li');
        var link = createElement(document, 'a', '', errors[fieldName]);
        link.href = '#' + field.id;
        item.appendChild(link);
        list.appendChild(item);
      }
    });
    if (summary) {
      summary.hidden = false;
      summary.focus();
    }
  }

  function currentInputUnit(component) {
    var checked = component.querySelector('[name="input_unit"]:checked');
    return checked && checked.value === 'metric' ? 'metric' : 'us';
  }

  function readForm(component) {
    var additional = [1, 2, 3].map(function (index) {
      return {
        name: component.querySelector('[name="additional_name_' + index + '"]').value,
        amount: component.querySelector('[name="additional_amount_' + index + '"]').value,
        phase: component.querySelector('[name="additional_phase_' + index + '"]').value
      };
    });
    var dilutionModeField = component.querySelector('[name="dilution_mode"]:checked');
    var dilutionMode = dilutionModeField ? dilutionModeField.value : '';
    var dilutionValue = dilutionMode === 'measured'
      ? component.querySelector('[name="dilution_measured"]').value
      : dilutionMode === 'service'
        ? 0
        : component.querySelector('[name="dilution_percent"]').value;
    return {
      planSource: component.querySelector('[name="plan_source"]').value,
      servings: component.querySelector('[name="servings"]').value,
      overagePercent: component.querySelector('[name="overage"]').value,
      custom: {
        name: component.querySelector('[name="custom_name"]').value,
        unit: currentInputUnit(component),
        baseName: component.querySelector('[name="custom_base_name"]').value,
        baseAmount: component.querySelector('[name="custom_base_amount"]').value,
        cordialAmount: component.querySelector('[name="custom_cordial_amount"]').value,
        additional: additional
      },
      dilution: {
        mode: dilutionMode,
        value: dilutionValue
      }
    };
  }

  function planContext(dataset, source) {
    if (source === 'custom') {
      return 'Enter one measured base, the Cordial Craft pour, and up to three optional measured ingredients.';
    }
    if (source.indexOf('preset:') === 0) {
      var preset = findPreset(dataset, source.slice(7));
      return preset ? preset.description + '. Test and adjust within the complete recipe.' : '';
    }
    if (source.indexOf('recipe:') === 0) {
      var recipe = findRecipe(dataset, source.slice(7));
      return recipe ? recipe.lede : '';
    }
    return '';
  }

  function updatePlanPanel(component, dataset) {
    var select = component.querySelector('[name="plan_source"]');
    var panel = component.querySelector('[data-custom-panel]');
    var context = component.querySelector('[data-plan-context]');
    var isCustom = select.value === 'custom';
    panel.hidden = !isCustom;
    panel.disabled = !isCustom;
    context.textContent = planContext(dataset, select.value);
  }

  function updateDilutionPanel(component) {
    var selected = component.querySelector('[name="dilution_mode"]:checked');
    var mode = selected ? selected.value : 'service';
    var measuredPanel = component.querySelector('[data-dilution-panel="measured"]');
    var percentPanel = component.querySelector('[data-dilution-panel="percent"]');
    var measuredInput = component.querySelector('[name="dilution_measured"]');
    var percentInput = component.querySelector('[name="dilution_percent"]');
    var percentHelp = component.querySelector('[data-dilution-help]');
    measuredPanel.hidden = mode !== 'measured';
    measuredInput.disabled = mode !== 'measured';
    percentPanel.hidden = mode !== 'base_percent' && mode !== 'finished_percent';
    percentInput.disabled = mode !== 'base_percent' && mode !== 'finished_percent';
    if (mode === 'base_percent') {
      percentHelp.textContent = 'Formula: added water ÷ undiluted pre-batch liquid × 100.';
    } else if (mode === 'finished_percent') {
      percentHelp.textContent = 'Formula: added water ÷ (undiluted pre-batch liquid + added water) × 100.';
    } else {
      percentHelp.textContent = '';
    }
  }

  function convertVolumeInputs(component, oldUnit, newUnit) {
    if (oldUnit === newUnit) {
      return;
    }
    component.querySelectorAll('[data-volume-input]').forEach(function (input) {
      if (String(input.value).trim() === '') {
        return;
      }
      var value = numberValue(input.value);
      if (!isFiniteNumber(value) || value < 0) {
        return;
      }
      var converted = newUnit === 'metric'
        ? value * ML_PER_US_FLOZ
        : value / ML_PER_US_FLOZ;
      input.value = String(roundTo(converted, newUnit === 'metric' ? 1 : 3));
    });
  }

  function updateUnitLabels(component, unit) {
    component.querySelectorAll('[data-input-unit-label]').forEach(function (label) {
      label.textContent = unit === 'metric' ? 'mL' : 'U.S. fl oz';
    });
  }

  function renderGroup(component, phase, items) {
    var group = component.querySelector('[data-result-group="' + phase + '"]');
    var list = group ? group.querySelector('[data-result-list]') : null;
    if (!group || !list) {
      return;
    }
    list.replaceChildren();
    if (!items.length) {
      group.hidden = true;
      return;
    }
    items.forEach(function (item) {
      var row = createElement(document, 'li', 'ccbc-result-item');
      var label = createElement(document, 'span', 'ccbc-result-label', item.label);
      var value = createElement(
        document,
        'strong',
        'ccbc-result-value',
        item.scaled.kind === 'volume'
          ? formatVolumeDual(item.scaled)
          : item.scaled.per_serving_text
      );
      var context = createElement(
        document,
        'small',
        'ccbc-result-context',
        item.scaled.kind === 'volume'
          ? item.id.indexOf('-advance-water') > -1
            ? 'User-selected advance water; included in pre-service total'
            : 'Scaled for target servings and measured-liquid buffer'
          : 'Per serving; preserve as a manual step'
      );
      row.append(label, value, context);
      list.appendChild(row);
    });
    group.hidden = false;
  }

  function renderBottlePlans(component, result) {
    var requirement = component.querySelector('[data-bottle-requirement]');
    var options = component.querySelector('[data-bottle-options]');
    var note = component.querySelector('[data-bottle-note]');
    options.replaceChildren();
    if (!result.bottlePlans.eligible) {
      requirement.textContent = result.bottlePlans.reason;
      note.textContent = 'Choose one exact Cordial Craft amount per drink before ordering bottles or making the batch.';
      return;
    }
    requirement.textContent =
      'Plan requires ' +
      formatVolumeDual(exactRange(result.bottlePlans.requiredMl)) +
      ' Cordial Craft.';
    result.bottlePlans.formats.forEach(function (format) {
      var card = createElement(document, 'div', 'ccbc-bottle-option');
      var count = createElement(document, 'strong', '', String(format.count));
      var label = createElement(
        document,
        'span',
        '',
        format.sizeMl + ' mL bottle' + (format.count === 1 ? '' : 's')
      );
      var context = createElement(
        document,
        'small',
        '',
        'Nominal volume above the plan: ' + formatMlNumber(format.nominalRemainderMl) + ' mL'
      );
      card.append(count, label, context);
      options.appendChild(card);
    });
    note.textContent =
      'Each option uses only one bottle size and rounds up to whole bottles. This is a planning comparison, not an availability claim; verify the format before ordering.';
  }

  function renderResult(component, result) {
    var results = component.querySelector('[data-results]');
    var title = component.querySelector('[data-result-title]');
    var summary = component.querySelector('[data-result-summary]');
    var recipeLink = component.querySelector('[data-recipe-link]');
    var serviceList = component.querySelector('[data-service-notes]');
    title.textContent = result.plan.name;
    summary.textContent =
      result.servings +
      ' target servings' +
      (result.overagePercent > 0
        ? ' with a ' + result.overagePercent + '% measured-liquid buffer.'
        : ' with no measured-liquid buffer.');
    component.querySelector('[data-total-batch]').textContent = formatVolumeDual(result.totals.batch);
    component.querySelector('[data-total-per-serving]').textContent = formatVolumeDual(result.totals.perServingBatch);
    component.querySelector('[data-total-service]').textContent = formatVolumeDual(result.totals.service);
    component.querySelector('[data-total-complete]').textContent = formatVolumeDual(result.totals.complete);
    component.querySelector('[data-dilution-record]').textContent = dilutionSummary(result);
    PHASES.forEach(function (phase) {
      renderGroup(component, phase, result.groups[phase]);
    });
    renderBottlePlans(component, result);
    serviceList.replaceChildren();
    serviceNotes(result).forEach(function (note) {
      serviceList.appendChild(createElement(document, 'li', '', note));
    });
    if (result.plan.url) {
      recipeLink.href = result.plan.url;
      recipeLink.textContent = 'Read the complete ' + result.plan.name + ' recipe';
      recipeLink.hidden = false;
    } else {
      recipeLink.hidden = true;
      recipeLink.removeAttribute('href');
    }
    results.hidden = false;
    component.__ccBatchResult = result;
  }

  function clearResult(component) {
    var results = component.querySelector('[data-results]');
    if (results) {
      results.hidden = true;
    }
    component.__ccBatchResult = null;
  }

  function announce(component, message) {
    var status = component.querySelector('[data-status]');
    if (status) {
      status.textContent = '';
      root.setTimeout(function () {
        status.textContent = message;
      }, 20);
    }
  }

  function clearRuntimeBanner(unavailable) {
    if (!unavailable) {
      return;
    }
    unavailable.textContent = '';
    unavailable.hidden = true;
  }

  function copyText(text) {
    if (
      root.navigator &&
      root.navigator.clipboard &&
      typeof root.navigator.clipboard.writeText === 'function' &&
      root.isSecureContext
    ) {
      return root.navigator.clipboard.writeText(text);
    }
    return new Promise(function (resolve, reject) {
      var textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.setAttribute('readonly', '');
      textarea.className = 'ccbc-copy-fallback';
      document.body.appendChild(textarea);
      textarea.select();
      textarea.setSelectionRange(0, textarea.value.length);
      try {
        var copied = document.execCommand('copy');
        textarea.remove();
        if (!copied) {
          reject(new Error('Copy command was not accepted.'));
          return;
        }
        resolve();
      } catch (error) {
        textarea.remove();
        reject(error);
      }
    });
  }

  function initializeComponent(component) {
    if (!component || component.getAttribute('data-cc-batch-ready') === 'true') {
      return;
    }
    component.setAttribute('data-cc-batch-ready', 'true');
    var dataId = component.getAttribute('data-data-id');
    var dataNode = dataId ? document.getElementById(dataId) : null;
    var unavailable = component.querySelector('[data-unavailable]');
    var form = component.querySelector('[data-calculator-form]');
    var runtimeFields = component.querySelector('[data-runtime-fields]');
    var manualFallback = component.querySelector('[data-manual-fallback]');
    var dataset;
    try {
      dataset = JSON.parse(dataNode ? dataNode.textContent : '');
      var dataErrors = validateDataset(dataset);
      if (dataErrors.length) {
        throw new Error(dataErrors.join(' '));
      }
    } catch (error) {
      if (form) {
        form.hidden = true;
        form.setAttribute('inert', '');
      }
      if (runtimeFields) {
        runtimeFields.disabled = true;
      }
      if (unavailable) {
        unavailable.hidden = false;
        unavailable.textContent =
          'The interactive calculator is temporarily unavailable. Use the manual starting points and batching guide below.';
      }
      return;
    }

    var select = component.querySelector('[name="plan_source"]');
    var recipeGroup = document.createElement('optgroup');
    recipeGroup.label = 'Cordial Craft recipes';
    dataset.recipes.forEach(function (recipe) {
      var option = document.createElement('option');
      option.value = 'recipe:' + recipe.handle;
      option.textContent = recipe.name;
      recipeGroup.appendChild(option);
    });
    select.appendChild(recipeGroup);
    component.__ccInputUnit = currentInputUnit(component);
    updatePlanPanel(component, dataset);
    updateDilutionPanel(component);
    updateUnitLabels(component, component.__ccInputUnit);

    select.addEventListener('change', function () {
      updatePlanPanel(component, dataset);
      clearErrors(component);
      clearResult(component);
      announce(component, planContext(dataset, select.value));
    });
    component.querySelectorAll('[name="dilution_mode"]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        updateDilutionPanel(component);
        clearResult(component);
        announce(component, radio.closest('label').innerText.replace(/\s+/g, ' ').trim());
      });
    });
    component.querySelectorAll('[name="input_unit"]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        var nextUnit = currentInputUnit(component);
        convertVolumeInputs(component, component.__ccInputUnit, nextUnit);
        component.__ccInputUnit = nextUnit;
        updateUnitLabels(component, nextUnit);
        clearResult(component);
        announce(
          component,
          nextUnit === 'metric'
            ? 'Custom and measured-water inputs now use milliliters.'
            : 'Custom and measured-water inputs now use U.S. fluid ounces.'
        );
      });
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      clearRuntimeBanner(unavailable);
      clearErrors(component);
      var input = readForm(component);
      try {
        var result = calculate(dataset, input);
        renderResult(component, result);
        clearRuntimeBanner(unavailable);
        announce(component, 'Batch plan calculated for ' + result.servings + ' target servings of ' + result.plan.name + '.');
        component.querySelector('[data-result-title]').focus();
      } catch (error) {
        clearResult(component);
        if (error && error.code === 'INVALID_INPUT') {
          renderErrors(component, error.fields);
          announce(component, 'The batch plan could not be calculated. Review the highlighted fields.');
          return;
        }
        if (error && error.code === 'RESULT_TOO_LARGE') {
          renderErrors(component, {
            servings: 'This plan exceeds the calculator’s working volume. Reduce servings, buffer, component amounts, or the tested water value.'
          });
          announce(component, 'The plan exceeds the calculator working volume.');
          return;
        }
        if (unavailable) {
          unavailable.hidden = false;
          unavailable.textContent = 'The calculator could not complete this plan. Review the inputs or use the manual guide.';
          unavailable.focus();
        }
      }
    });

    form.addEventListener('reset', function () {
      root.setTimeout(function () {
        component.__ccInputUnit = currentInputUnit(component);
        updateUnitLabels(component, component.__ccInputUnit);
        updatePlanPanel(component, dataset);
        updateDilutionPanel(component);
        clearRuntimeBanner(unavailable);
        clearErrors(component);
        clearResult(component);
        announce(component, 'Calculator reset to the 2:1 starting point with no advance water.');
        select.focus();
      }, 0);
    });

    component.querySelector('[data-copy]').addEventListener('click', function () {
      if (!component.__ccBatchResult) {
        announce(component, 'Build a batch plan before copying.');
        return;
      }
      copyText(plainTextSummary(component.__ccBatchResult)).then(
        function () {
          announce(component, 'Batch plan copied to the clipboard.');
        },
        function () {
          announce(component, 'Automatic copy was unavailable. Select the visible results and copy them manually.');
        }
      );
    });

    component.querySelector('[data-print]').addEventListener('click', function () {
      if (!component.__ccBatchResult) {
        announce(component, 'Build a batch plan before printing.');
        return;
      }
      root.print();
    });

    if (runtimeFields) {
      runtimeFields.disabled = false;
    }
    form.removeAttribute('inert');
    form.hidden = false;
    if (manualFallback) {
      manualFallback.hidden = true;
    }
    clearRuntimeBanner(unavailable);
  }

  function initializeAll() {
    if (typeof document === 'undefined') {
      return;
    }
    document.querySelectorAll('[data-cc-batch-calculator]').forEach(initializeComponent);
  }

  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
    } else {
      initializeAll();
    }
    document.addEventListener('shopify:section:load', initializeAll);
  }

  root.CCBatchCalculator = Object.assign({}, core, { initializeAll: initializeAll });
})(typeof globalThis !== 'undefined' ? globalThis : this);
